export default {
  title: 'Artigos Populares',
  list: {
    empty_list: {
      title: 'Ainda sem artigos populares.',
    },
    fields: {
      name: 'Nome',
      orders: 'Pedidos',
      sales: 'Vendas',
    },
  },
};
